// extracted by mini-css-extract-plugin
export var heroImage = "_lg-1";
export var modal = "_lg-0";